import Vue from 'vue';
import VueGtm from '@gtm-support/vue2-gtm';
import Router from 'vue-router';

Vue.use(Router);

import routes from '../config/routes.js';

const router = new Router({
	scrollBehavior: function (to, _from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}
		if (to.hash) {
			return {el: to.hash, behavior: "smooth"};
		} else {
			window.scrollTo(0, 0);
		}
	},
	mode: (process.env.VUE_APP_TYPE === 'widget') ? 'hash' : 'history',
	base: "/",
	routes: routes
});

Vue.use(VueGtm, {
	enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
	id: 'GTM-WN2BZR7', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
	defer: true, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
	compatibility: true, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
	nonce: '2726c7f26c', // Will add `nonce` to the script tag
	debug: true, // Whether or not display console logs debugs (optional)
	loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
	vueRouter: router, // Pass the router instance to automatically sync with router (optional)
	ignoredViews: ['test'], // Don't trigger events for specified router names (optional)
	trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

export default router;
